import { fetchGetService } from '@/modules/api'

const state = {
  isReady: false
}

const getters = {
  getIsReady: state => state.isReady
}

const mutations = {
  UPDATE_IS_READY: (state, boolean) => {
    state.isReady = boolean
  }
}

const actions = {
  async fetchGetCommon ({ commit, dispatch }) {
    dispatch('page/updateLoaded', false, { root: true })
    const { data } = await fetchGetService('common')
    if (data.header) dispatch('updateHeader', data.header)
    if (data.myspace) dispatch('updateMyspace', data.myspace)
    if (data.footer) dispatch('updateFooter', data.footer)
    dispatch('page/updateLoaded', true, { root: true })
  },
  updateIsReady: ({ commit }, status) => {
    commit('UPDATE_IS_READY', status)
  },
  updateHeader: ({ dispatch }, data) => {
    dispatch('header/updatePublicSite', data.publicSite, { root: true })
    dispatch('header/updateHelp', data.help, { root: true })
    dispatch('header/updateMySpace', data.mySpace, { root: true })
    dispatch('header/updateDashboard', data.dashboard, { root: true })
    dispatch('header/updateMenu', data.menu, { root: true })
    dispatch('header/updateSearch', data.search, { root: true })
    dispatch('header/updateProfile', data.profile, { root: true })
  },
  updateMyspace: ({ dispatch }, data) => {
    dispatch('myspace/updateStewardship', data.stewardship, { root: true })
    dispatch('myspace/updateDocuments', data.documents, { root: true })
    dispatch('myspace/updateEvents', data.events, { root: true })
    dispatch('myspace/updateWorkgroups', data.workgroups, { root: true })
    dispatch('myspace/updateHolidays', data.holidays, { root: true })
    dispatch('myspace/updateTravels', data.travels, { root: true })
    dispatch('myspace/updateRemoteWorking', data.remoteWorking, { root: true })
  },
  updateFooter: ({ dispatch }, data) => {
    dispatch('footer/updateCopyright', data.copyright, { root: true })
    dispatch('footer/updateGdpr', data.gdpr, { root: true })
    dispatch('footer/updateMenu', data.menu, { root: true })
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
